import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import * as _ from 'lodash';

import { environment } from 'environments/environment';
import { CommonService } from '../../../../../common/services/Common.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { ChatService } from '../../../../../common/services/Chat.service';


declare var $: any;

@Component({
    moduleId: module.id,
    selector: "chat-config",
    templateUrl: './chat_config.component.html',
    styleUrls: [],
    providers: [CommonService]
})

@Injectable()
export class ChatConfigComponent implements OnInit {
    public model : any = {};
    public embed :any = '';
    public tab : any = 'tab-config';
    constructor(
        private commonService : CommonService,
        private uploadService : UploadService,
        private chatService : ChatService,
        private toastr: ToastrService) {
    }

    ngOnInit() {
        let user = JSON.parse(localStorage.getItem('User'));
        let _tenant_id = user.tenant_id ?  user.tenant_id : user.id;
        this.embed = '<script type="text/javascript">function loadJsAsync(t, e) { var n = document.createElement("script"); n.type = "text/javascript", n.src = t, n.addEventListener("load", function (t) { e(null, t) }, !1); var a = document.getElementsByTagName("head")[0]; a.appendChild(n) } window.addEventListener("DOMContentLoaded", function () { loadJsAsync("'+environment.url_embed+'/js/3cChat.js?v=2.1'+'", function () { var t = { domain: "", tenant_id:"'+_tenant_id+'" }; embedCsChat(t) }) }, !1);</script><!-- End of widget script -->';
       this.loadData()
       
    }


    
    loadData(request: any = {}) {
        this.chatService.config().subscribe(res => {
            if(!res.error) {
                this.model = res.data ? res.data : {};
                if(this.model && this.model.logo && this.model.logo != '') {
                    this.model.url_logo = this.commonService.file(this.model.logo);
                }
            }
        })
    }

    changeFile($event) {
        var files = $event.srcElement.files;
        this.uploadService.upload(files[0]).then((res: any) => {
            if(!res.error) {
                this.model.logo = res.data;
                this.model.url_logo = this.commonService.file(this.model.logo);
                $event.target.value = null;
            } else {
                this.toastr.error(res.data.message, 'Lỗi', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
        })
    }

    changeTab(tab) {
        this.tab = tab;
        this.loadData();
    }
    
    updateConfig() {
        delete this.model.url_logo;
        this.chatService.updateConfig(this.model).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.toastr.error('Cập nhật thất bại', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Cập nhật thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                }
            }
        }, error => {
            this.toastr.error('Cập nhật thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        });
    }

    
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/chat/chat_config.component.ts